import { Routes, Route } from "react-router-dom";
import Navbar from './assets/components/Navbar/Navbar';
import Footer from './assets/components/Footer/Footer';

import Home from './assets/components/Home/Home';

import Predefine_Colar_SoccerPage from './assets/pages/Predefine_Colar_SoccerPage';
import Predefine_ColarFull_SoccerPage from './assets/pages/Predefine_ColarFull_SoccerPage';
import Predefine_PoloNack_SoccerPage from './assets/pages/Predefine_PoloNack_SoccerPage';
import Predefine_PoloNackFull_SoccerPage from './assets/pages/Predefine_PoloNackFull_SoccerPage';
import Predefine_Vnack_SoccerPage from './assets/pages/Predefine_Vnack_SoccerPage';
import Predefine_VnackFull_SoccerPage from './assets/pages/Predefine_VnackFull_SoccerPage';


import Predefine_2_Colar_SoccerPage from "./assets/pages/Predefine_2_Colar_SoccerPage";
import Predefine_2_ColarFull_Soccer from "./assets/components/Predefine_2_ColarFull_Soccer/Predefine_2_ColarFull_Socce";
import Predefine_2_PoloNack_Soccer from "./assets/components/Predefine_2_PoloNack_Soccer/Predefine_2_PoloNack_Soccer";
import Predefine_2_PoloNackFull_Soccer from "./assets/components/Predefine_2_PoloNackFull_Soccer/Predefine_2_PoloNackFull_Soccer"
import Predefine_2_Vnack_Soccer from "./assets/components/Predefine_2_Vnack_Soccer/Predefine_2_Vnack_Soccer"
import Predefine_2_VnackFull_Soccer from "./assets/components/Predefine_2_VnackFull_Soccer/Predefine_2_VnackFull_Soccer"
import Predefine_Colar_CricketPage from './assets/pages/Predefine_Colar_CricketPage';
import Predefine_2_CricketPage from './assets/pages/Predefine_2_CricketPage';
import Predefine_3_CricketPage from './assets/pages/Predefine_3_CricketPage';
import Predefine_Colar_BasketballPage from './assets/pages/Predefine_Colar_BasketballPage';
import Predefine_2_BasketballPage from './assets/pages/Predefine_2_BasketballPage';
import Predefine_2_Colar_GoalkeeperPage from './assets/pages/Predefine_2_Colar_GoalkeeperPage';
import Predefine_Colar_GoalkeeperPage from './assets/pages/Predefine_Colar_GoalkeeperPage';

import FormPage from "./assets/pages/FormPage";
import CartPage from "./assets/pages/CartPage";
import CheckoutPage from "./assets/pages/CheckoutPage";



function App() {
  return (
    <div className="App">
      <Navbar />
 
  <Routes>
  <Route path="/" element={<Home />} />

  {/* Soccer */}
  <Route path="/Predefine_Colar_Soccer" element={<Predefine_Colar_SoccerPage />} />
  <Route path="/colar" element={<Predefine_Colar_SoccerPage />} />
  <Route path="/colar-full" element={<Predefine_ColarFull_SoccerPage />} />

  <Route path="/colar-design-2" element={<Predefine_2_Colar_SoccerPage />} />

  <Route path="/polo" element={<Predefine_PoloNack_SoccerPage />} />
  <Route path="/polo-full" element={<Predefine_PoloNackFull_SoccerPage />} />

  <Route path="/vnack" element={<Predefine_Vnack_SoccerPage />} />
  <Route path="/vnack-full" element={<Predefine_VnackFull_SoccerPage />} />

  {/* Soccer v2 */}
  <Route path="/Predefine_2_Colar_Soccer" element={<Predefine_2_Colar_SoccerPage />} />
  <Route path="/colar-2" element={<Predefine_2_Colar_SoccerPage />} />
  <Route path="/colar-2-full" element={<Predefine_2_ColarFull_Soccer />} />

  <Route path="/polo-2" element={<Predefine_2_PoloNack_Soccer />} />
  <Route path="/polo-2-full" element={<Predefine_2_PoloNackFull_Soccer />} />

  <Route path="/vnack-2" element={<Predefine_2_Vnack_Soccer />} />
  <Route path="/vnack-2-full" element={<Predefine_2_VnackFull_Soccer />} />

  {/* Other Kits */}
  <Route path="/cricket" element={<Predefine_Colar_CricketPage />} />
    <Route path="/cricket-2" element={<Predefine_2_CricketPage />} />
        <Route path="/cricket-3" element={<Predefine_3_CricketPage />} />
  <Route path="/basket" element={<Predefine_Colar_BasketballPage />} />
    <Route path="/basket-2" element={<Predefine_2_BasketballPage />} />
    <Route path="/goalkeeper-2" element={<Predefine_2_Colar_GoalkeeperPage />} />
  <Route path="/goalkeeper" element={<Predefine_Colar_GoalkeeperPage />} />

  {/* FLOW (VERY IMPORTANT) */}
  <Route path="/details" element={<FormPage />} />
  <Route path="/cart" element={<CartPage />} />
  <Route path="/checkout" element={<CheckoutPage />} />
</Routes>

     
      <Footer />
    </div>
  );
}

export default App;
